import {
  BillableItemSelectOption,
  BillableItemSummary,
} from "../types/billableItemAssignment";
import { getBillableItemUnitLabel } from "./billableItemFormOptions";

/** e.g. "#12 Warehouse charge — $1,500.00 Per Month" */
export function billableItemAssignmentOptionLabel(
  billableItem: BillableItemSummary,
  formatCurrency: (amount: string) => string
): string {
  return `#${billableItem.displayId} ${billableItem.name} — ${formatCurrency(
    billableItem.amount
  )} ${getBillableItemUnitLabel(billableItem.unit)}`;
}

export function buildBillableItemSelectOptions(
  billableItems: BillableItemSummary[],
  formatCurrency: (amount: string) => string
): BillableItemSelectOption[] {
  return billableItems.map((billableItem) => ({
    id: billableItem.id,
    label: billableItemAssignmentOptionLabel(billableItem, formatCurrency),
  }));
}
